import {
  HomePageCid, ProductCardMc, ProductCardMv, ProductCardGroupInfoMv, ProductCardGroupInfoMC
} from './constant';

// 默认为首页cid
let currentCid = HomePageCid;
export interface LxFilterParams {
  sort_code: string;
  sort_name: string;
  filter_code: string;
  filter_name: string;
}

const Statistics = Mach.requireModule('Statistics');

const shopActivity = {
  fullReduction: 2, // 满减
  fullDiscountActivity: 3, // 满折
  feeFree: 4, // 免配送费
  promoDishes: 18, // 折扣菜
  deliveryActivity: 21, // 配送费活动
};

// 灵犀埋点上报参数处理
export const handleLXParam = (data: any, shop_index: number, biz_trace_id: any) => {
  const logData = data?.logData || {};

  return {
    biz_trace_id,
    shop_index,
    page_source: currentCid,
    is_pop: 0,
    ...logData,
  };
};

export const reportProductCardMc = (data: any, shop_index: number, bizTraceId: string, isProductCard: boolean = true) => {
  const params = handleLXParam(data, shop_index, bizTraceId);
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [currentCid]: {
      ...params,
      bid: ProductCardMc,
    },
  });
  Statistics.click(currentCid, isProductCard ? ProductCardMc : ProductCardGroupInfoMC, params);
};

export const reportProductCardMv = (data: any, shop_index: number, bizTraceId: string) => {
  const params = handleLXParam(data, shop_index, bizTraceId);
  Statistics.view(currentCid, ProductCardMv, params);

  if (data.shopGroupInfo?.shopIdList?.length > 0) {
    Statistics.view(currentCid, ProductCardGroupInfoMv, params);
  }
};

/**
 * 设置cid
 */
export const setCid = ((cid: string) => {
  currentCid = cid || HomePageCid;
});
